(() => {
  const compact = window.matchMedia('(max-aspect-ratio: 1)');
  const cleanups = new Map();
  function initializeFooters(scope = document) {
    scope.querySelectorAll('.footer-content').forEach((footer) => {
      if (cleanups.has(footer)) return;
      const items = [...footer.querySelectorAll('.accordion-item')];
      const setState = (item, expanded) => {
        const trigger = item.querySelector('button.footer-column-title');
        const content = item.querySelector('.accordion-content');
        if (!trigger || !content) return;
        item.classList.toggle('active', expanded);
        trigger.setAttribute('aria-expanded', String(expanded));
        // Match visual visibility and keyboard reachability during the collapse transition.
        content.inert = !expanded;
      };
      const sync = () => items.forEach((item) => {
        const trigger = item.querySelector('button.footer-column-title');
        if (!trigger) return;
        trigger.disabled = !compact.matches;
        setState(item, !compact.matches);
      });
      const controller = new AbortController();
      items.forEach((item) => {
        const trigger = item.querySelector('button.footer-column-title');
        trigger?.addEventListener('click', () => {
          if (!compact.matches) return;
          const expanded = trigger.getAttribute('aria-expanded') !== 'true';
          items.forEach((other) => setState(other, other === item && expanded));
        }, { signal: controller.signal });
      });
      compact.addEventListener('change', sync);
      cleanups.set(footer, () => {
        compact.removeEventListener('change', sync);
        controller.abort();
        cleanups.delete(footer);
      });
      sync();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initializeFooters(), { once: true });
  else initializeFooters();
  document.addEventListener('shopify:section:load', (event) => initializeFooters(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll('.footer-content').forEach((footer) => cleanups.get(footer)?.());
  });
})();
